module.exports = __webpack_public_path__ + "media/images/logos/National-University-of-Singapore-0a3b27f081760b0fefb56aa54bd03ad0.svg";